import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "text-weight-bolder" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Tillgängliga:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Avställda:", -1)
const _hoisted_5 = { style: { textAlign: 'right' } }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Orsak till att inte tillgängliga ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Fordon ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Avställningsdepå ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Avställd ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Prognos ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Anledning ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Kommentar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
    return (_openBlock(), _createBlock(_component_q_table, {
      key: item.type,
      flat: "",
      class: _normalizeClass(["q-mt-md", _ctx.$style.table]),
      bordered: "",
      rows: item.vehicles,
      columns: _ctx.columns,
      "hide-bottom": "",
      separator: "cell",
      "rows-per-page-options": [0]
    }, {
      header: _withCtx((props) => [
        _createVNode(_component_q_tr, {
          props: props,
          style: { textAlign: 'left' },
          class: "bg-grey-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_th, { colspan: "4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, _toDisplayString(item.label) + " (Antal)", 1),
                    _hoisted_3,
                    _hoisted_4
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(item.value.total), 1),
                    _createElementVNode("div", null, _toDisplayString(item.value.available), 1),
                    _createElementVNode("div", null, _toDisplayString(item.value.withdrawn), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_th, { colspan: "2" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["props"]),
        _createVNode(_component_q_tr, {
          props: props,
          style: { textAlign: 'left' },
          class: _normalizeClass(["bg-grey-3", _ctx.$style.subHeader])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_th, { style: {"width":"75px","min-width":"75px","max-width":"75px"} }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_th, { style: {"width":"120px","min-width":"120px","max-width":"120px"} }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_th, { style: {"width":"100px","min-width":"100px","max-width":"100px"} }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_q_th, { style: {"width":"100px","min-width":"100px","max-width":"100px"} }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_q_th, { style: {"width":"150px","min-width":"150px","max-width":"150px"} }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_q_th, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["props", "class"])
      ]),
      _: 2
    }, 1032, ["class", "rows", "columns"]))
  }), 128))
}